import { Injectable, Inject } from '@angular/core';
import { SysbizConfigService, SysbizConfig } from './sysbiz-config.service';
import { HttpResponseBase } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export abstract class SysbizService {

  /**
   * Type of API
   */
  readonly api: string;

  /**
   * API version
   */
  readonly version: string = 'v3';

  constructor(
    @Inject(SysbizConfigService) protected config: SysbizConfig
  ) { }

  /**
   * Compose URL for API call
   * @param endpoint Path to API endpoint
   * @param parameters Optional query parameters
   */
  protected url(
    endpoint: string,
    parameters?: { [key: string]: any }
  ): string {    // Assemble url
    let url: string = this.config.domain;

    // Optional: port
    if (this.config.port)
      url += `:${this.config.port}`;

    url += '/';

    // Optional: path prefix
    if (this.config.pathPrefix)
      url += `${this.config.pathPrefix}/`;

    // API type (archive, conservation, customer)
    if (this.api)
      url += `${this.api}/`;

    // Optional: path prefix
    if (this.version)
      url += `${this.version}/`;

    // Endpoint
    url += endpoint;

    // Add query parameters
    if (parameters) {
      let query = [];
      for (let key of Object.keys(parameters)) {
        let param = parameters[key];
        if (param.constructor == 'Array') {
          if (param.length == 1)
            query.push(key + '=' + param[0]);
          else
            for (let value of param)
              query.push(key + '[]=' + value);
        } else
          query.push(key + '=' + param);
      }
      url += '?' + query.join('&');
    }

    return url;
  }
}
